export default __webpack_public_path__ + "static/media/bit6.c1a61c31.svg";